import * as Yup from "yup";

export const kycRejectSchema = Yup.object().shape({
  reason: Yup.string()
  .trim()
  .min(10, "Reason must be at least 10 characters")
  .required("Please provide a reason for rejection"),
});